const API_ENVIRONMENTS = {
  local: {
    baseUrl: "http://localhost:8040",
    apiPrefix: "api/v1",
  },
  // local: {
  //   baseUrl: "https://jokingly-smoking-blooming.ngrok-free.dev",
  //   apiPrefix: "api/v1",
  // },
  stage: {
    baseUrl: "https://inventoryapi.anaxistech.com",
    apiPrefix: "api/v1",
  },
  live: {
    baseUrl: "https://inventoryliveapi.anaxistech.com",
    apiPrefix: "api/v1",
  },
};

function trimSlashes(value = "") {
  return value.replace(/^\/+|\/+$/g, "");
}

function trimTrailingSlash(value = "") {
  return value.replace(/\/+$/g, "");
}

function getEnvValue(name, fallback) {
  const value = process.env[name];
  return value === undefined ? fallback : value.trim();
}

function getApiEnvironment(value = "") {
  return value.split("//")[0].trim().toLowerCase();
}

function buildApiBaseUrl(baseUrl, apiPrefix) {
  const cleanBaseUrl = trimTrailingSlash(baseUrl);
  const cleanApiPrefix = trimSlashes(apiPrefix);

  if (!cleanBaseUrl) return "";
  if (!cleanApiPrefix) return cleanBaseUrl;

  return `${cleanBaseUrl}/${cleanApiPrefix}`;
}

const apiEnvironment = (
  getApiEnvironment(process.env.REACT_APP_API_ENV) ||
  process.env.REACT_APP_ENV ||
  "local"
).toLowerCase();
const environmentDefaults =
  API_ENVIRONMENTS[apiEnvironment] || API_ENVIRONMENTS.local;

const baseUrl = getEnvValue(
  "REACT_APP_API_BASE_URL",
  environmentDefaults.baseUrl,
);
const apiPrefix = getEnvValue(
  "REACT_APP_API_PREFIX",
  environmentDefaults.apiPrefix,
);

export const API_CONFIG = {
  environment: apiEnvironment,
  baseUrl,
  apiPrefix,
  apiBaseUrl: buildApiBaseUrl(baseUrl, apiPrefix),
};
